module.exports = __webpack_public_path__ + "static/img/kh-15.e60c67d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-15.png
// module id = D33n
// module chunks = 5